import React from 'react';
import { useTheme } from '@mui/material';

const NextWave = () => {
  const theme = useTheme();

  return (
    <svg width="24" height="12" viewBox="0 0 24 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9675 6.09692C11.3149 5.90741 11.3149 5.40853 10.9675 5.21902L1.51164 0.0612946C1.17846 -0.120444 0.772217 0.120712 0.772217 0.500242V10.8157C0.772217 11.1952 1.17846 11.4364 1.51164 11.2546L10.9675 6.09692ZM22.9675 6.09691C23.3149 5.90741 23.3149 5.40853 22.9675 5.21902L13.5116 0.0612898C13.1784 -0.120449 12.7722 0.120708 12.7722 0.500237V10.8157C12.7722 11.1952 13.1784 11.4364 13.5116 11.2546L22.9675 6.09691Z"
        fill={theme.palette.text.extraLight}
      />
    </svg>
  );
};

export default NextWave;
